export enum InterfaceUserTypes {
  DOCTORS = "DOCTORS",
  DOCTORS_ERROR = "DOCTORS_ERROR",
  DOCTORS_LOADER = "DOCTORS_LOADER",
}

export interface ISpecialist {
  id: number;
  specialist_category: ISpecialistCategory;
  avatar: any;
  name: string;
  title_en: string;
  title_de: string;
  title_fr: string;
  bio_en: string;
  bio_de: string;
  bio_fr: string;
  workplace_en: string;
  workplace_de: string;
  workplace_fr: string;
  whatsapp: string;
  phone: string;
  email: string;
  is_active: boolean;
  created_at: string;
  modified_at: string;
}

export interface ISpecialistCategory {
  id: number;
  name_en: string;
  name_de: string;
  name_fr: string;
}

export interface IDoctorsState {
  doctors: ISpecialist[];
  error: string | any | null;
  loading: boolean;
  categories: ISpecialistCategory[];
}

interface IActionGetUser {
  type: InterfaceUserTypes.DOCTORS;
  payload: {
    doctors: ISpecialist[];
    categories: ISpecialistCategory[];
  };
}

interface IActionLoaderUser {
  type: InterfaceUserTypes.DOCTORS_LOADER;
  payload: boolean;
}

interface IActionErrorUser {
  type: InterfaceUserTypes.DOCTORS_ERROR;
  payload: string | unknown;
}

export type ActionTypesUser =
  | IActionErrorUser
  | IActionGetUser
  | IActionLoaderUser;
